export const datePattern = /^(0[1-9]|1[012])-([1-9]|([012][0-9])|(3[01]))-(19|20)\d{2}\s([0-1]?[0-9]|2?[0-3]):([0-5]\d)$/;
export const datePattern12 = /^(0[1-9]|1[012])-([1-9]|([012][0-9])|(3[01]))-(19|20)\d{2}\s([0-1]?[0-9]|2?[0-3]):([0-5]\d) (AM|PM)$/;
export const ethereumAddressPattern = /^0x[a-fA-F0-9]{40}$/;
export const nullableEthereumAddressPattern = /^(0x[a-fA-F0-9]{40})?$/;
